import { z } from "zod";

export const AuditoriaAauditoriaSchema = z.object({
  Evento: z.string().nullable().optional(),
  TipoAuditoria: z.number().nullable().optional(),
  EmAberto: z.coerce.number().nullable().optional(),
  DataElaboracao: z.coerce.date({ invalid_type_error: "Data de elaboração inválida."}).nullable().optional(),
  DataAuditoria:  z.coerce.date({ invalid_type_error: "Data de auditoria inválida."}),
  DataTermino: z.coerce.date({ invalid_type_error: "Data de termino inválida."}).nullable().optional(),
  Criterio: z.string().nullable().optional(),
  Observacao: z.string().nullable().optional(),
  IdAuditor1: z.number().nullable().optional(),
  IdAuditor2: z.number().nullable().optional(),
  IdAuditor3: z.number().nullable().optional(),
  Arquivo1: z.instanceof(File).nullable().optional(),
  Arquivo2: z.instanceof(File).nullable().optional(),
  nomeArquivo1: z.string().nullable().optional(),
  nomeArquivo2: z.string().nullable().optional(),
  limparArquivo1: z.boolean().default(false),
  limparArquivo2: z.boolean().default(false),

  //Extra front
  download1: z.string().nullable().optional(),
  download2: z.string().nullable().optional(),
});

// AuditoriaAauditoriaForm

export type AuditoriaAauditoriaForm = z.infer<typeof AuditoriaAauditoriaSchema>;